import React from "react";
import {FormattedMessage, injectIntl} from "react-intl";

import IconButton from "@mui/material/IconButton";
import ErrorIcon from "@mui/icons-material/Error";

const LookMainDeleteNotification = (props) => {

  const {intl} = props;

  return (
    <div className="lm-notification">
      <IconButton aria-label={intl.formatMessage({id:"iconButton.info"})}
                  className="look-icon look-icon--small look-icon--yellow">
        <ErrorIcon/>
      </IconButton>
      <p className="lm-notification__text">
        <FormattedMessage id="look.features.deleteNotification"/>
      </p>
    </div>
  )
};

export default injectIntl(LookMainDeleteNotification)
